import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-2xl font-serif text-depto-brown mb-4" data-id="element-71">
      Política de Privacidad
    </h3>
    <p className="text-depto-brown/70 mb-4" data-id="element-72">Última actualización: Abril 2026</p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-73">
      1. Información que recopilamos
    </h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-74">
      Al realizar tu compra, recopilamos únicamente los datos necesarios para
      procesar la transacción: nombre, dirección de correo electrónico y datos
      de pago. No almacenamos información de tarjetas de crédito ni datos
      financieros sensibles.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-75">
      2. Uso de la información
    </h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-76">
      Utilizamos tu información exclusivamente para: enviar el producto digital
      adquirido, comunicar actualizaciones del material y responder consultas
      relacionadas con tu compra.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-77">
      3. Protección de datos
    </h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-78">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tu información personal contra acceso no autorizado, alteración o
      destrucción.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-79">
      4. Compartir información
    </h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-80">
      No vendemos, alquilamos ni compartimos tu información personal con
      terceros, excepto cuando sea necesario para procesar tu pago a través de
      plataformas de pago seguras.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-81">5. Tus derechos</h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-82">
      Podés solicitar acceso, rectificación o eliminación de tus datos
      personales en cualquier momento enviándonos un mensaje.
    </p>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-serif text-depto-brown mb-4" data-id="element-83">
      Términos y Condiciones
    </h3>
    <p className="text-depto-brown/70 mb-4" data-id="element-84">Última actualización: Abril 2026</p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-85">
      1. Producto digital
    </h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-86">
      DEPTO-DOG es un producto digital en formato PDF. Al completar la compra,
      recibirás acceso inmediato para descargar el material. Debido a la
      naturaleza digital del producto, no se aceptan devoluciones una vez
      realizada la descarga.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-87">2. Uso personal</h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-88">
      El contenido adquirido es para uso personal y exclusivo del comprador.
      Queda prohibida la reproducción, distribución, reventa o publicación total
      o parcial del material sin autorización expresa.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-89">3. Resultados</h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-90">
      Los resultados pueden variar según cada perro y la constancia en la
      aplicación del método. DEPTO-DOG no garantiza resultados específicos ya
      que cada animal es único. En casos de problemas graves de comportamiento,
      recomendamos consultar con un veterinario o etólogo.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-91">4. Actualizaciones</h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-92">
      Al adquirir el producto, tenés acceso de por vida a la versión actual y
      futuras actualizaciones del material sin costo adicional.
    </p>

    <h4 className="font-bold text-depto-brown mt-6 mb-2" data-id="element-93">
      5. Propiedad intelectual
    </h4>
    <p className="text-depto-brown/80 mb-3" data-id="element-94">
      Todo el contenido de DEPTO-DOG, incluyendo textos, imágenes y metodología,
      está protegido por derechos de autor. El uso indebido del material podrá
      dar lugar a acciones legales.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-depto-brown py-8 px-5 text-center border-t border-white/10" data-id="element-95">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 mb-4" data-id="element-96">
          <button onClick={() => setActiveModal('privacy')} className="text-depto-cream/50 hover:text-depto-amber text-sm transition-colors" data-id="element-97">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline text-depto-cream/20" data-id="element-98">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-depto-cream/50 hover:text-depto-amber text-sm transition-colors" data-id="element-99">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-depto-cream/40 text-sm" data-id="element-100">
          © {new Date().getFullYear()} DEPTO-DOG. Todos los derechos
          reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-101">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-102">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-depto-cream rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-103">
              <div className="sticky top-0 bg-depto-cream border-b border-depto-brown/10 p-4 flex items-center justify-between rounded-t-2xl z-10" data-id="element-104">
                <h2 className="font-serif text-depto-brown text-lg" data-id="element-105">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-depto-brown/10 transition-colors" data-id="element-106">
                  <X className="w-5 h-5 text-depto-brown" data-id="element-107" />
                </button>
              </div>
              <div className="p-6 text-sm leading-relaxed" data-id="element-108">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}